import React from 'react';
import { useCommonDataTableUiTranslation } from '../../hooks';
import { TextCell } from './TextCell';
export function TableCellContent({ column, row }) {
    const { t } = useCommonDataTableUiTranslation();
    if (column.cellField) {
        const fieldValue = row[column.cellField];
        let fieldText = '';
        switch (typeof fieldValue) {
            case 'boolean':
                if (fieldValue) {
                    fieldText = column.trueLabel != null ? column.trueLabel : t('cellContentTrue');
                }
                else {
                    fieldText = column.falseLabel != null ? column.falseLabel : t('cellContentFalse');
                }
                break;
            case 'number':
                if (column.numberFormat) {
                    fieldText = column.numberFormat.format(fieldValue);
                }
                else {
                    fieldText = fieldValue.toString();
                }
                break;
            case 'string':
                fieldText = fieldValue;
                break;
        }
        return (React.createElement(TextCell, { textOverflowAfterLines: column.textOverflowAfterLines, showToolbarWhenTextOverflows: column.showToolbarWhenTextOverflows }, fieldText));
    }
    else if (column.cellFunction) {
        return React.createElement(React.Fragment, null, column.cellFunction(row));
    }
    else if (column.cellComponent) {
        const CellComponent = column.cellComponent;
        return React.createElement(CellComponent, { row: row });
    }
    else {
        return React.createElement(React.Fragment, null);
    }
}
